import React, { useState } from "react";
import { Container, Row, Col, Modal } from "react-bootstrap";
import { motion } from "framer-motion";
import "./Gallery.css"; // pour les styles personnalisés

const images = [
  "/images/services/service6.jpg",
  "/images/services/service6a.jpg",
  "/images/services/service6b.jpg",
  "/images/services/service6c.jpg",
  "/images/services/service6d.jpg",
  "/images/services/service6e.jpg",
];

const GalleryLoungs = () => {
  const [showModal, setShowModal] = useState(false);
  const [currentImg, setCurrentImg] = useState("");

  const openModal = (img) => {
    setCurrentImg(img);
    setShowModal(true);
  };

  const closeModal = () => setShowModal(false);

  return (
    <Container className="py-0">
      <motion.h2
        className="text-center mb-3 fw-bold"
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
      >
        Galerie Airport Lounge
      </motion.h2>

      <Row xs={1} sm={2} md={3} className="g-4">
        {images.map((img, idx) => (
          <Col key={idx}>
            <motion.div
              className="gallery-card"
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.97 }}
              onClick={() => openModal(img)}
            >
              <img src={img} alt={`img-${idx}`} className="gallery-img" />
              <motion.div
                className="gallery-overlay"
                initial={{ opacity: 0 }}
                whileHover={{ opacity: 1 }}
                transition={{ duration: 0.3 }}
              >
                <span className="overlay-text">Voir l'image</span>
              </motion.div>
            </motion.div>
          </Col>
        ))}
      </Row>

      {/* Modal */}
      <Modal show={showModal} onHide={closeModal} centered size="lg">
        <Modal.Body className="p-0 bg-dark">
          <img src={currentImg} alt="Selected" className="w-100" />
        </Modal.Body>
      </Modal>
    </Container>
  );
};

export default GalleryLoungs;
